import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

import { Button, Col, Input, Row, Select } from "antd";
import ButtonGroup from "antd/es/button/button-group";
import { Option } from "antd/es/mentions";
import Modal from "antd/es/modal/Modal";
import moment from "moment";

import nutrientsApi from "../../../../apis/Nutrients.api";
import { setLoading } from "../../../../redux/store/common/commonDuck";

const NutrientsRequestCreateComponent = () => {
  let history = useHistory();
  const dispatch = useDispatch();

  const user = useSelector((state) => state.auth.user);
  // const isLoading = useSelector((state) => state.common.loading);

  const setIsLoading = (value) => dispatch(setLoading(value));

  let editState = true;

  const [isModalVisible, setIsModalVisible] = useState(false);
  // const [error, setError] = useState("");

  // const [confirmHistory, setConfirmHistory] = useState({
  // 	target_type: 3,
  // 	confirm: 0,
  // 	confirm_reason: "",
  // });

  const confirmHistory = {
    target_type: 3,
    confirm: 0,
    confirm_reason: "",
  };
  const typeItems = [
    { typeType: "brand_type", typeValue: 1, typeText: "영양제브랜드" },
  ];

  const statusItems = [
    { statusType: "status", statusValue: 0, statusText: "신청" },
  ];

  const certifyItems = [
    { certifyType: "is_certify", certifyValue: false, certifyText: "미인증" },
  ];

  const nutritionFactsUnitItems = [
    {
      nutritionUnitType: "nutrition_facts_unit",
      nutritionUnitValue: "mg",
      nutritionUnitText: "mg",
    },
    {
      nutritionUnitType: "nutrition_facts_unit",
      nutritionUnitValue: "g",
      nutritionUnitText: "g",
    },
    {
      nutritionUnitType: "nutrition_facts_unit",
      nutritionUnitValue: "ml",
      nutritionUnitText: "ml",
    },
  ];

  const forPersonUnitItems = [
    {
      personUnitType: "for_person_unit",
      personUnitValue: "g",
      personUnitText: "g",
    },
    {
      personUnitType: "for_person_unit",
      personUnitValue: "ml",
      personUnitText: "ml",
    },
    {
      personUnitType: "for_person_unit",
      personUnitValue: "듀얼포",
      personUnitText: "듀얼포",
    },
    {
      personUnitType: "for_person_unit",
      personUnitValue: "방울",
      personUnitText: "방울",
    },
    {
      personUnitType: "for_person_unit",
      personUnitValue: "병",
      personUnitText: "병",
    },
    {
      personUnitType: "for_person_unit",
      personUnitValue: "분사",
      personUnitText: "분사",
    },
    {
      personUnitType: "for_person_unit",
      personUnitValue: "정",
      personUnitText: "정",
    },
    {
      personUnitType: "for_person_unit",
      personUnitValue: "정제",
      personUnitText: "정제",
    },
    {
      personUnitType: "for_person_unit",
      personUnitValue: "캡슐",
      personUnitText: "캡슐",
    },
    {
      personUnitType: "for_person_unit",
      personUnitValue: "포",
      personUnitText: "포",
    },
    {
      personUnitType: "for_person_unit",
      personUnitValue: "회",
      personUnitText: "회",
    },
  ];

  const [nutrientsData, setNutrientsData] = useState({
    status: "",
    name: "", //영양제명
    brand_type: "",
    is_certify: "", //헬씨팀 인증 여부
    nutrition_facts: "", //분량
    nutrition_facts_unit: "", // 분량 단위
    energy: "", //칼로리(㎉)
    for_person: "", //인분 수
    for_person_unit: "", //인분 단위
    category: "",
    brand_name: "",
    created_at: "", //생성일
    created_by_name: "", //생성자
    created_by: 0,
    updated_at: "", //수정일
    updated_by_name: "", //수정자
  });

  const contentName = {
    status: "상태",
    name: "영양제명",
    brand_type: "브랜드타입",
    is_certify: "헬씨팀 인증여부",
    nutrition_facts: "분량",
    nutrition_facts_unit: " 분량 단위",
    energy: "칼로리(㎉)",
    for_person: "인분 수",
    for_person_unit: "인분 단위",
  };

  const [nutrientsNutrient, setNutrientsNutrient] = useState({
    target_type: 3,
    moisture: "", //수분(g)
    protein: "", //단백질(g)
    fat: "", //지방(g)
    carbohydrate: "", //탄수화물(g)
    total_sugar: "", //총당류(g)
    total_dietary_fiber: "", //총식이섬유(g)
    soluble_dietary_fiber: "", //수용성 식이섬유(g)
    insoluble_dietary_fiber: "", //불용성 식이섬유	(g)
    calcium: "", //칼슘(mg)
    fe: "", //철(mg)
    magnesium: "", //마그네슘(mg)
    perfect_virtue: "", //인(㎎)
    potassium: "", //칼륨(㎎)
    sodium: "", //나트륨(㎎)
    zinc: "", //아연(㎎)
    copper: "", //구리(㎎)
    manganese: "", //망간(㎎)
    selenium: "", //셀레늄(㎍)
    molybdenum: "", //몰리브덴(㎍)
    iodine: "", //요오드(㎍)
    retinol: "", //레티놀(㎍)
    beta_carotene: "", //베타카로틴(㎍)
    vitamin_a: "", //비타민 A(D2+D3)(㎍)
    vitamin_d: "", //비타민 D(D2+D3)(㎍)
    vitamin_e: "", //비타민 E(㎎)
    vitamin_k: "", //비타민 K(㎍)
    vitamin_k1: "", //비타민 K1(㎍)
    vitamin_k2: "", //비타민 K2(㎍)
    vitamin_b1: "", //비타민 B1(㎎)
    vitamin_b2: "", //비타민 B2(㎎)

    Niacin: "", //나이아신(mg NE)사용

    niacin: "", //나이아신(㎎)
    niacin_1: "", //나이아신(㎎ NE)
    niacin_2: "", //나이아신(NE)(㎎)
    niacin_3: "", //나이아신(NE)(㎎ NE)

    nicotinic_acid: "", //니코틴산 (㎎)
    nicotinamide: "", //니코틴아마이드(㎎)
    pantothenic_acid: "", //판토텐산(㎎)
    vitamin_b6: "", //비타민 B6(㎎)
    pyridoxine: "", //피리독신(㎎)
    biotin: "", //비오틴(㎍)
    folic_acid: "", //엽산(DFE)(㎍)
    vitamin_b12: "", //비타민 B12(㎍)
    vitamin_c: "", //비타민 C(㎎)

    cholesterol: "", //콜레스테롤(g)
    cholesterol_1: "", //콜레스테롤(㎎)

    total_fatty_acids: "", //총 지방산(g)
    total_essential_fatty_acids: "", //총 필수 지방산(g)
    total_saturated_fatty_acids: "", //총 포화 지방산(g)
    total_saturated_fatty_acids_1: "", //총 포화 지방산(%)

    linoleic_acid: "", //리놀레산(18:2(n-6)c)(㎎)
    alpha_linolenic_acid: "", //알파 리놀렌산(18:3(n-3))(㎎)
    eicosadienoic_acid: "", //에이코사디에노산(20:2(n-6))(㎎)
    omega_3_fatty_acids: "", //오메가 3 지방산(g)
    omega_6_fatty_acids: "", //오메가 6 지방산(g)
    choline: "", //콜린(㎎)
    tryptophan: "", //트립토판(㎎)
    arginine: "", //아르기닌(㎎)
    cysteine: "", //시스테인(㎎)
    taurine: "", //타우린(㎎)
    gamma_linolenic_acid: "", //감마 리놀렌산(18:3(n-6))(㎎)
    arachidonic_acid: "", //아라키돈산(20:4(n-6))(㎎)
    docosahexaenoic_acid: "", //도코사헥사에노산(22:6(n-3))(㎎)
    trans_fatty_acids: "", //트랜스 지방산(g)
    caffeine: "", //카페인
  });

  // const showModal = () => {
  // 	setIsModalVisible(true);
  // };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const handleClickCancel = () => {
    history.go(-1);
  };

  const handleClickComplete = async () => {
    setIsLoading(true);
    setIsModalVisible(false);
    for (let i = 0; i < Object.keys(contentName)?.length; i++) {
      if (nutrientsData[Object.keys(contentName)[i]] === "") {
        return alert(Object.values(contentName)[i] + "을(를) 입력해주세요.");
      }
    }
    const createNutrients = {
      nutrients: nutrientsData,
      nutrients_nutrient: nutrientsNutrient,
      confirmHistory: confirmHistory,
    };
    createNutrients.nutrients.created_by = user.id;
    createNutrients.nutrients.created_by_name = user.nickname;
    try {
      // setError("");
      const res = await nutrientsApi.createNutrients(createNutrients);
      if (res.code === 200) {
        setIsLoading(false);
        window.alert("영양제정보등록이 완료되었습니다.");
        history.go(-1);
      } else {
        setIsLoading(false);
        window.alert("정상적인 요청이 아닙니다.");
      }
    } catch (error) {
      setIsLoading(false);
      console.log(error);
      // setError(error);
    }
  };

  const onChange = (e) => {
    if (e.target.name === "nutrients") {
      setNutrientsData({ ...nutrientsData, [e.target.id]: e.target.value });
    } else if (e.target.name === "nutrientsNutrient") {
      setNutrientsNutrient({
        ...nutrientsNutrient,
        [e.target.id]: e.target.value,
      });
    } else {
      console.log("onChange Error", e.target.name);
    }
  };

  const onSelectChange = (value, e) => {
    setNutrientsData({ ...nutrientsData, [e.id]: value });
  };
  const handleClickMenu = (e) => {
    history.go(-1);
  };

  return (
    <div style={{ height: "auto" }}>
      <ButtonGroup
        style={{
          marginTop: 10,
          marginRight: 40,
          display: "flex",
          justifyContent: "left",
        }}
      >
        <Button
          style={{
            width: 100,
            height: 30,
            marginBottom: 20,
            borderColor: "#17721b",
          }}
          onClick={(e) => handleClickMenu(e)}
        >
          목록으로
        </Button>
      </ButtonGroup>
      <Modal
        title="영양제정보저장"
        visible={isModalVisible}
        maskClosable={false}
        onOk={handleClickComplete}
        onCancel={handleCancel}
      >
        <p>영양제 정보를 저장하시겠습니까?</p>
      </Modal>
      <Row>
        <Col span={5}>
          <Row>
            <Col
              span={21}
              style={{
                textAlign: "center",
                border: "groove",
                height: 30,
                marginBottom: 15,
              }}
            >
              영양제 정보
            </Col>
          </Row>
          <Row>
            <Col
              span={10}
              style={{
                border: "double",
                paddingLeft: 3,
                backgroundColor: "#eaeaea",
                height: 30,
              }}
            >
              상태
            </Col>
            <Col span={10} offset={1} style={{ height: 30 }}>
              <Select
                style={{ width: 113 }}
                placeholder="상태"
                onChange={onSelectChange}
              >
                {statusItems.map((items, idx) => {
                  return (
                    <Option
                      value={items.statusValue}
                      id={items.statusType}
                      key={`statusText-${idx}`}
                    >
                      {items.statusText}
                    </Option>
                  );
                })}
              </Select>
            </Col>
          </Row>
          <Row style={{ marginTop: 5 }}>
            <Col
              span={10}
              style={{
                border: "double",
                backgroundColor: "#eaeaea",
                paddingLeft: 3,
                height: 30,
              }}
            >
              카테고리
            </Col>
            {editState ? (
              <Col
                span={10}
                offset={1}
                style={{ border: "groove", height: 30 }}
              >
                <Input
                  style={{ height: 25, border: "none" }}
                  placeholder="수정할 값을 입력하세요."
                  id="category"
                  name="nutrients"
                  allowClear
                  onChange={onChange}
                />
              </Col>
            ) : (
              <Col
                span={10}
                offset={1}
                style={{ border: "groove", height: 30, paddingLeft: 10 }}
              >
                {nutrientsData.category}
              </Col>
            )}
          </Row>
          <Row style={{ marginTop: 5 }}>
            <Col
              span={10}
              style={{
                border: "double",
                backgroundColor: "#eaeaea",
                paddingLeft: 3,
                height: 30,
              }}
            >
              영양제명
            </Col>
            {editState ? (
              <Col
                span={10}
                offset={1}
                style={{ border: "groove", height: 30 }}
              >
                <Input
                  style={{ height: 25, border: "none" }}
                  placeholder="수정할 값을 입력하세요."
                  id="name"
                  name="nutrients"
                  allowClear
                  onChange={onChange}
                />
              </Col>
            ) : (
              <Col
                span={10}
                offset={1}
                style={{ border: "groove", height: 30, paddingLeft: 10 }}
              >
                {nutrientsData.name}
              </Col>
            )}
          </Row>

          <Row style={{ marginTop: 5 }}>
            <Col
              span={10}
              style={{
                border: "double",
                backgroundColor: "#eaeaea",
                paddingLeft: 3,
                height: 30,
              }}
            >
              영양제브랜드
            </Col>
            {editState ? (
              <Col
                span={10}
                offset={1}
                style={{ border: "groove", height: 30 }}
              >
                <Input
                  style={{ height: 25, border: "none" }}
                  placeholder="수정할 값을 입력하세요."
                  id="brand_name"
                  name="nutrients"
                  allowClear
                  onChange={onChange}
                />
              </Col>
            ) : (
              <Col
                span={10}
                offset={1}
                style={{ border: "groove", height: 30, paddingLeft: 10 }}
              >
                {nutrientsData.brand_name}
              </Col>
            )}
          </Row>
          <Row style={{ marginTop: 5 }}>
            <Col
              span={10}
              style={{
                border: "double",
                backgroundColor: "#eaeaea",
                paddingLeft: 3,
                height: 30,
              }}
            >
              브랜드타입
            </Col>
            {editState ? (
              <Col span={10} offset={1} style={{ height: 30 }}>
                <Select
                  style={{ width: 113 }}
                  placeholder="영양제브랜드타입"
                  onChange={onSelectChange}
                >
                  {typeItems.map((items) => {
                    return (
                      <Option value={items.typeValue} id={items.typeType}>
                        {items.typeText}
                      </Option>
                    );
                  })}
                </Select>
              </Col>
            ) : (
              <Col
                span={10}
                offset={1}
                style={{ border: "groove", height: 30, paddingLeft: 10 }}
              >
                {nutrientsData.brand_type}
              </Col>
            )}
          </Row>
          <Row style={{ marginTop: 5 }}>
            <Col
              span={10}
              style={{
                border: "double",
                fontSize: "smaller",
                backgroundColor: "#eaeaea",
                paddingLeft: 3,
                height: 30,
              }}
            >
              헬씨팀 인증여부
            </Col>
            {editState ? (
              <Col span={10} offset={1} style={{ height: 30 }}>
                <Select
                  style={{ width: 113 }}
                  placeholder="인증여부"
                  onChange={onSelectChange}
                >
                  {certifyItems.map((items) => {
                    return (
                      <Option value={items.certifyValue} id={items.certifyType}>
                        {items.certifyText}
                      </Option>
                    );
                  })}
                </Select>
              </Col>
            ) : (
              <Col
                span={10}
                offset={1}
                style={{ border: "groove", height: 30, paddingLeft: 10 }}
              >
                {nutrientsData.is_certify === true ? "인증" : "미인증"}
              </Col>
            )}
          </Row>
          <Row style={{ marginTop: 5 }}>
            <Col
              span={10}
              style={{
                border: "double",
                backgroundColor: "#eaeaea",
                paddingLeft: 3,
                height: 30,
              }}
            >
              분량
            </Col>
            {editState ? (
              <Col
                span={10}
                offset={1}
                style={{ border: "groove", height: 30 }}
              >
                <Input
                  type="number"
                  style={{ height: 25, border: "none" }}
                  placeholder="수정할 값을 입력하세요."
                  id="nutrition_facts"
                  name="nutrients"
                  allowClear
                  onChange={onChange}
                />
              </Col>
            ) : (
              <Col
                span={10}
                offset={1}
                style={{ border: "groove", height: 30, paddingLeft: 10 }}
              >
                {nutrientsData.nutrition_facts}
              </Col>
            )}
          </Row>
          <Row style={{ marginTop: 5 }}>
            <Col
              span={10}
              style={{
                border: "double",
                backgroundColor: "#eaeaea",
                paddingLeft: 3,
                height: 30,
              }}
            >
              분량 단위
            </Col>
            {editState ? (
              <Col span={10} offset={1} style={{ height: 30 }}>
                <Select
                  style={{ width: 113 }}
                  placeholder="단위선택"
                  onChange={onSelectChange}
                >
                  {nutritionFactsUnitItems.map((items) => {
                    return (
                      <Option
                        value={items.nutritionUnitValue}
                        id={items.nutritionUnitType}
                      >
                        {items.nutritionUnitText}
                      </Option>
                    );
                  })}
                </Select>
              </Col>
            ) : (
              <Col
                span={10}
                offset={1}
                style={{ border: "groove", height: 30, paddingLeft: 10 }}
              >
                {nutrientsData.nutrition_facts_unit}
              </Col>
            )}
          </Row>
          <Row style={{ marginTop: 5 }}>
            <Col
              span={10}
              style={{
                border: "double",
                backgroundColor: "#eaeaea",
                paddingLeft: 3,
                height: 30,
              }}
            >
              칼로리(kcal)
            </Col>
            {editState ? (
              <Col
                span={10}
                offset={1}
                style={{ border: "groove", height: 30 }}
              >
                <Input
                  type="number"
                  style={{ height: 25, border: "none" }}
                  placeholder="입력대기중..."
                  id="energy"
                  name="nutrients"
                  allowClear
                  onChange={onChange}
                />
              </Col>
            ) : (
              <Col
                span={10}
                offset={1}
                style={{ border: "groove", height: 30, paddingLeft: 10 }}
              >
                {nutrientsData.energy}
              </Col>
            )}
          </Row>
          <Row style={{ marginTop: 5 }}>
            <Col
              span={10}
              style={{
                border: "double",
                backgroundColor: "#eaeaea",
                paddingLeft: 3,
                height: 30,
              }}
            >
              인분 수
            </Col>
            {editState ? (
              <Col
                span={10}
                offset={1}
                style={{ border: "groove", height: 30 }}
              >
                <Input
                  type="number"
                  style={{ height: 25, border: "none" }}
                  placeholder="입력대기중..."
                  id="for_person"
                  name="nutrients"
                  allowClear
                  onChange={onChange}
                />
              </Col>
            ) : (
              <Col
                span={10}
                offset={1}
                style={{ border: "groove", height: 30, paddingLeft: 10 }}
              >
                {nutrientsData.for_person}
              </Col>
            )}
          </Row>
          <Row style={{ marginTop: 5 }}>
            <Col
              span={10}
              style={{
                border: "double",
                backgroundColor: "#eaeaea",
                paddingLeft: 3,
                height: 30,
                fontSize: "small",
              }}
            >
              인분 단위
            </Col>
            {editState ? (
              <Col span={10} offset={1} style={{ height: 30 }}>
                <Select
                  style={{ width: 113 }}
                  placeholder="단위선택"
                  onChange={onSelectChange}
                >
                  {forPersonUnitItems.map((items) => {
                    return (
                      <Option
                        value={items.personUnitValue}
                        id={items.personUnitType}
                      >
                        {items.personUnitText}
                      </Option>
                    );
                  })}
                </Select>
              </Col>
            ) : (
              <Col
                span={10}
                offset={1}
                style={{ border: "groove", height: 30, paddingLeft: 10 }}
              >
                {nutrientsData.for_person_unit}
              </Col>
            )}
          </Row>
        </Col>
        <Col span={19}>
          <Row>
            <Col
              span={24}
              style={{
                textAlign: "center",
                border: "groove",
                height: 30,
                marginLeft: 10,
                marginBottom: 15,
              }}
            >
              영양제 영양성분 정보
            </Col>
          </Row>
          <Row>
            <Col span={4}>
              <Row>
                <Col
                  span={10}
                  offset={1}
                  style={{
                    border: "double",
                    backgroundColor: "#eaeaea",
                    paddingLeft: 3,
                    height: 30,
                  }}
                >
                  식이섬유
                </Col>
                {editState ? (
                  <Col
                    span={9}
                    offset={1}
                    style={{ border: "groove", height: 30 }}
                  >
                    <Input
                      style={{ height: 25, border: "none" }}
                      placeholder="수정할 값을 입력하세요."
                      id="total_dietary_fiber"
                      name="nutrientsNutrient"
                      allowClear
                      onChange={onChange}
                    />
                  </Col>
                ) : (
                  <>
                    {nutrientsNutrient.total_dietary_fiber !== 0 ? (
                      <Col
                        span={9}
                        offset={1}
                        style={{
                          border: "groove",
                          height: 30,
                          backgroundColor: "#fff7f7",
                        }}
                      >
                        {nutrientsNutrient.total_dietary_fiber}
                      </Col>
                    ) : (
                      <Col
                        span={9}
                        offset={1}
                        style={{ border: "groove", height: 30 }}
                      >
                        {nutrientsNutrient.total_dietary_fiber}
                      </Col>
                    )}
                  </>
                )}
              </Row>
              <Row style={{ marginTop: 5 }}>
                <Col
                  span={10}
                  offset={1}
                  style={{
                    border: "double",
                    backgroundColor: "#eaeaea",
                    paddingLeft: 3,
                    height: 30,
                  }}
                >
                  칼슘
                </Col>
                {editState ? (
                  <Col
                    span={9}
                    offset={1}
                    style={{ border: "groove", height: 30 }}
                  >
                    <Input
                      style={{ height: 25, border: "none" }}
                      placeholder="수정할 값을 입력하세요."
                      id="calcium"
                      name="nutrientsNutrient"
                      allowClear
                      onChange={onChange}
                    />
                  </Col>
                ) : (
                  <>
                    {nutrientsNutrient.calcium !== 0 ? (
                      <Col
                        span={9}
                        offset={1}
                        style={{
                          border: "groove",
                          height: 30,
                          backgroundColor: "#fff7f7",
                        }}
                      >
                        {nutrientsNutrient.calcium + "(mg)"}
                      </Col>
                    ) : (
                      <Col
                        span={9}
                        offset={1}
                        style={{ border: "groove", height: 30 }}
                      >
                        {nutrientsNutrient.calcium}
                      </Col>
                    )}
                  </>
                )}
              </Row>
              <Row style={{ marginTop: 5 }}>
                <Col
                  span={10}
                  offset={1}
                  style={{
                    border: "double",
                    backgroundColor: "#eaeaea",
                    paddingLeft: 3,
                    height: 30,
                  }}
                >
                  철
                </Col>
                {editState ? (
                  <Col
                    span={9}
                    offset={1}
                    style={{ border: "groove", height: 30 }}
                  >
                    <Input
                      style={{ height: 25, border: "none" }}
                      placeholder="수정할 값을 입력하세요."
                      id="fe"
                      name="nutrientsNutrient"
                      allowClear
                      onChange={onChange}
                    />
                  </Col>
                ) : (
                  <>
                    {nutrientsNutrient.fe !== 0 ? (
                      <Col
                        span={9}
                        offset={1}
                        style={{
                          border: "groove",
                          height: 30,
                          backgroundColor: "#fff7f7",
                        }}
                      >
                        {nutrientsNutrient.fe + "(mg)"}
                      </Col>
                    ) : (
                      <Col
                        span={9}
                        offset={1}
                        style={{ border: "groove", height: 30 }}
                      >
                        {nutrientsNutrient.fe}
                      </Col>
                    )}
                  </>
                )}
              </Row>
              <Row style={{ marginTop: 5 }}>
                <Col
                  span={10}
                  offset={1}
                  style={{
                    border: "double",
                    backgroundColor: "#eaeaea",
                    paddingLeft: 3,
                    height: 30,
                  }}
                >
                  마그네슘
                </Col>
                {editState ? (
                  <Col
                    span={9}
                    offset={1}
                    style={{ border: "groove", height: 30 }}
                  >
                    <Input
                      style={{ height: 25, border: "none" }}
                      placeholder="수정할 값을 입력하세요."
                      id="magnesium"
                      name="nutrientsNutrient"
                      allowClear
                      onChange={onChange}
                    />
                  </Col>
                ) : (
                  <>
                    {nutrientsNutrient.magnesium !== 0 ? (
                      <Col
                        span={9}
                        offset={1}
                        style={{
                          border: "groove",
                          height: 30,
                          backgroundColor: "#fff7f7",
                        }}
                      >
                        {nutrientsNutrient.magnesium + "(mg)"}
                      </Col>
                    ) : (
                      <Col
                        span={9}
                        offset={1}
                        style={{ border: "groove", height: 30 }}
                      >
                        {nutrientsNutrient.magnesium}
                      </Col>
                    )}
                  </>
                )}
              </Row>
              <Row style={{ marginTop: 5 }}>
                <Col
                  span={10}
                  offset={1}
                  style={{
                    border: "double",
                    backgroundColor: "#eaeaea",
                    paddingLeft: 3,
                    height: 30,
                  }}
                >
                  아연
                </Col>
                {editState ? (
                  <Col
                    span={9}
                    offset={1}
                    style={{ border: "groove", height: 30 }}
                  >
                    <Input
                      style={{ height: 25, border: "none" }}
                      placeholder="수정할 값을 입력하세요."
                      id="zinc"
                      name="nutrientsNutrient"
                      allowClear
                      onChange={onChange}
                    />
                  </Col>
                ) : (
                  <>
                    {nutrientsNutrient.zinc !== 0 ? (
                      <Col
                        span={9}
                        offset={1}
                        style={{
                          border: "groove",
                          height: 30,
                          backgroundColor: "#fff7f7",
                        }}
                      >
                        {nutrientsNutrient.zinc + "(mg)"}
                      </Col>
                    ) : (
                      <Col
                        span={9}
                        offset={1}
                        style={{ border: "groove", height: 30 }}
                      >
                        {nutrientsNutrient.zinc}
                      </Col>
                    )}
                  </>
                )}
              </Row>
              <Row style={{ marginTop: 5 }}>
                <Col
                  span={10}
                  offset={1}
                  style={{
                    border: "double",
                    backgroundColor: "#eaeaea",
                    paddingLeft: 3,
                    height: 30,
                  }}
                >
                  구리
                </Col>
                {editState ? (
                  <Col
                    span={9}
                    offset={1}
                    style={{ border: "groove", height: 30 }}
                  >
                    <Input
                      style={{ height: 25, border: "none" }}
                      placeholder="수정할 값을 입력하세요."
                      id="copper"
                      name="nutrientsNutrient"
                      allowClear
                      onChange={onChange}
                    />
                  </Col>
                ) : (
                  <>
                    {nutrientsNutrient.copper !== 0 ? (
                      <Col
                        span={9}
                        offset={1}
                        style={{
                          border: "groove",
                          height: 30,
                          backgroundColor: "#fff7f7",
                        }}
                      >
                        {nutrientsNutrient.copper + "(mg)"}
                      </Col>
                    ) : (
                      <Col
                        span={9}
                        offset={1}
                        style={{ border: "groove", height: 30 }}
                      >
                        {nutrientsNutrient.copper}
                      </Col>
                    )}
                  </>
                )}
              </Row>
              <Row style={{ marginTop: 5 }}>
                <Col
                  span={10}
                  offset={1}
                  style={{
                    border: "double",
                    backgroundColor: "#eaeaea",
                    paddingLeft: 3,
                    height: 30,
                  }}
                >
                  망간
                </Col>
                {editState ? (
                  <Col
                    span={9}
                    offset={1}
                    style={{ border: "groove", height: 30 }}
                  >
                    <Input
                      style={{ height: 25, border: "none" }}
                      placeholder="수정할 값을 입력하세요."
                      id="manganese"
                      name="nutrientsNutrient"
                      allowClear
                      onChange={onChange}
                    />
                  </Col>
                ) : (
                  <>
                    {nutrientsNutrient.manganese !== 0 ? (
                      <Col
                        span={9}
                        offset={1}
                        style={{
                          border: "groove",
                          height: 30,
                          backgroundColor: "#fff7f7",
                        }}
                      >
                        {nutrientsNutrient.manganese + "(mg)"}
                      </Col>
                    ) : (
                      <Col
                        span={9}
                        offset={1}
                        style={{ border: "groove", height: 30 }}
                      >
                        {nutrientsNutrient.manganese}
                      </Col>
                    )}
                  </>
                )}
              </Row>
              <Row style={{ marginTop: 5 }}>
                <Col
                  span={10}
                  offset={1}
                  style={{
                    border: "double",
                    backgroundColor: "#eaeaea",
                    paddingLeft: 3,
                    height: 30,
                  }}
                >
                  셀레늄
                </Col>
                {editState ? (
                  <Col
                    span={9}
                    offset={1}
                    style={{ border: "groove", height: 30 }}
                  >
                    <Input
                      style={{ height: 25, border: "none" }}
                      placeholder="수정할 값을 입력하세요."
                      id="selenium"
                      name="nutrientsNutrient"
                      allowClear
                      onChange={onChange}
                    />
                  </Col>
                ) : (
                  <>
                    {nutrientsNutrient.selenium !== 0 ? (
                      <Col
                        span={9}
                        offset={1}
                        style={{
                          border: "groove",
                          height: 30,
                          backgroundColor: "#fff7f7",
                        }}
                      >
                        {nutrientsNutrient.selenium + "(㎍)"}
                      </Col>
                    ) : (
                      <Col
                        span={9}
                        offset={1}
                        style={{ border: "groove", height: 30 }}
                      >
                        {nutrientsNutrient.selenium}
                      </Col>
                    )}
                  </>
                )}
              </Row>
              <Row style={{ marginTop: 5 }}>
                <Col
                  span={10}
                  offset={1}
                  style={{
                    border: "double",
                    backgroundColor: "#eaeaea",
                    paddingLeft: 3,
                    height: 30,
                  }}
                >
                  몰리브덴
                </Col>
                {editState ? (
                  <Col
                    span={9}
                    offset={1}
                    style={{ border: "groove", height: 30 }}
                  >
                    <Input
                      style={{ height: 25, border: "none" }}
                      placeholder="수정할 값을 입력하세요."
                      id="molybdenum"
                      name="nutrientsNutrient"
                      allowClear
                      onChange={onChange}
                    />
                  </Col>
                ) : (
                  <>
                    {nutrientsNutrient.molybdenum !== 0 ? (
                      <Col
                        span={9}
                        offset={1}
                        style={{
                          border: "groove",
                          height: 30,
                          backgroundColor: "#fff7f7",
                        }}
                      >
                        {nutrientsNutrient.molybdenum + "(㎍)"}
                      </Col>
                    ) : (
                      <Col
                        span={9}
                        offset={1}
                        style={{ border: "groove", height: 30 }}
                      >
                        {nutrientsNutrient.molybdenum}
                      </Col>
                    )}
                  </>
                )}
              </Row>
              <Row style={{ marginTop: 5 }}>
                <Col
                  span={10}
                  offset={1}
                  style={{
                    border: "double",
                    backgroundColor: "#eaeaea",
                    paddingLeft: 3,
                    height: 30,
                  }}
                >
                  요오드
                </Col>
                {editState ? (
                  <Col
                    span={9}
                    offset={1}
                    style={{ border: "groove", height: 30 }}
                  >
                    <Input
                      style={{ height: 25, border: "none" }}
                      placeholder="수정할 값을 입력하세요."
                      id="iodine"
                      name="nutrientsNutrient"
                      allowClear
                      onChange={onChange}
                    />
                  </Col>
                ) : (
                  <>
                    {nutrientsNutrient.iodine !== 0 ? (
                      <Col
                        span={9}
                        offset={1}
                        style={{
                          border: "groove",
                          height: 30,
                          backgroundColor: "#fff7f7",
                        }}
                      >
                        {nutrientsNutrient.iodine + "(㎍)"}
                      </Col>
                    ) : (
                      <Col
                        span={9}
                        offset={1}
                        style={{ border: "groove", height: 30 }}
                      >
                        {nutrientsNutrient.iodine}
                      </Col>
                    )}
                  </>
                )}
              </Row>
              <Row style={{ marginTop: 5 }}>
                <Col
                  span={10}
                  offset={1}
                  style={{
                    border: "double",
                    backgroundColor: "#eaeaea",
                    paddingLeft: 3,
                    height: 30,
                  }}
                >
                  비타민 A
                </Col>
                {editState ? (
                  <Col
                    span={9}
                    offset={1}
                    style={{ border: "groove", height: 30 }}
                  >
                    <Input
                      style={{ height: 25, border: "none" }}
                      placeholder="수정할 값을 입력하세요."
                      id="vitamin_a"
                      name="nutrientsNutrient"
                      allowClear
                      onChange={onChange}
                    />
                  </Col>
                ) : (
                  <>
                    {nutrientsNutrient.vitamin_a !== 0 ? (
                      <Col
                        span={9}
                        offset={1}
                        style={{
                          border: "groove",
                          height: 30,
                          backgroundColor: "#fff7f7",
                        }}
                      >
                        {nutrientsNutrient.vitamin_a + "(㎍)"}
                      </Col>
                    ) : (
                      <Col
                        span={9}
                        offset={1}
                        style={{ border: "groove", height: 30 }}
                      >
                        {nutrientsNutrient.vitamin_a}
                      </Col>
                    )}
                  </>
                )}
              </Row>
              <Row style={{ marginTop: 5 }}>
                <Col
                  span={10}
                  offset={1}
                  style={{
                    border: "double",
                    backgroundColor: "#eaeaea",
                    paddingLeft: 3,
                    height: 30,
                  }}
                >
                  비타민 D
                </Col>
                {editState ? (
                  <Col
                    span={9}
                    offset={1}
                    style={{ border: "groove", height: 30 }}
                  >
                    <Input
                      style={{ height: 25, border: "none" }}
                      placeholder="수정할 값을 입력하세요."
                      id="vitamin_d"
                      name="nutrientsNutrient"
                      allowClear
                      onChange={onChange}
                    />
                  </Col>
                ) : (
                  <>
                    {nutrientsNutrient.vitamin_d !== 0 ? (
                      <Col
                        span={9}
                        offset={1}
                        style={{
                          border: "groove",
                          height: 30,
                          backgroundColor: "#fff7f7",
                        }}
                      >
                        {nutrientsNutrient.vitamin_d + "(㎍)"}
                      </Col>
                    ) : (
                      <Col
                        span={9}
                        offset={1}
                        style={{ border: "groove", height: 30 }}
                      >
                        {nutrientsNutrient.vitamin_d}
                      </Col>
                    )}
                  </>
                )}
              </Row>
              <Row style={{ marginTop: 5 }}>
                <Col
                  span={10}
                  offset={1}
                  style={{
                    border: "double",
                    backgroundColor: "#eaeaea",
                    paddingLeft: 3,
                    height: 30,
                  }}
                >
                  비타민 E
                </Col>
                {editState ? (
                  <Col
                    span={9}
                    offset={1}
                    style={{ border: "groove", height: 30 }}
                  >
                    <Input
                      style={{ height: 25, border: "none" }}
                      placeholder="수정할 값을 입력하세요."
                      id="vitamin_e"
                      name="nutrientsNutrient"
                      allowClear
                      onChange={onChange}
                    />
                  </Col>
                ) : (
                  <>
                    {nutrientsNutrient.vitamin_e !== 0 ? (
                      <Col
                        span={9}
                        offset={1}
                        style={{
                          border: "groove",
                          height: 30,
                          backgroundColor: "#fff7f7",
                        }}
                      >
                        {nutrientsNutrient.vitamin_e + "(mg)"}
                      </Col>
                    ) : (
                      <Col
                        span={9}
                        offset={1}
                        style={{ border: "groove", height: 30 }}
                      >
                        {nutrientsNutrient.vitamin_e}
                      </Col>
                    )}
                  </>
                )}
              </Row>
              <Row style={{ marginTop: 5 }}>
                <Col
                  span={10}
                  offset={1}
                  style={{
                    border: "double",
                    backgroundColor: "#eaeaea",
                    paddingLeft: 3,
                    height: 30,
                  }}
                >
                  비타민 K
                </Col>
                {editState ? (
                  <Col
                    span={9}
                    offset={1}
                    style={{ border: "groove", height: 30 }}
                  >
                    <Input
                      style={{ height: 25, border: "none" }}
                      placeholder="수정할 값을 입력하세요."
                      id="vitamin_k"
                      name="nutrientsNutrient"
                      allowClear
                      onChange={onChange}
                    />
                  </Col>
                ) : (
                  <>
                    {nutrientsNutrient.vitamin_k !== 0 ? (
                      <Col
                        span={9}
                        offset={1}
                        style={{
                          border: "groove",
                          height: 30,
                          backgroundColor: "#fff7f7",
                        }}
                      >
                        {nutrientsNutrient.vitamin_k + "(㎍)"}
                      </Col>
                    ) : (
                      <Col
                        span={9}
                        offset={1}
                        style={{ border: "groove", height: 30 }}
                      >
                        {nutrientsNutrient.vitamin_k}
                      </Col>
                    )}
                  </>
                )}
              </Row>
            </Col>
            <Col span={5}>
              <Row>
                <Col
                  span={10}
                  style={{
                    border: "double",
                    backgroundColor: "#eaeaea",
                    paddingLeft: 3,
                    height: 30,
                  }}
                >
                  티아민(비타민 B1)
                </Col>
                {editState ? (
                  <Col
                    span={9}
                    offset={1}
                    style={{ border: "groove", height: 30 }}
                  >
                    <Input
                      style={{ height: 25, border: "none" }}
                      placeholder="수정할 값을 입력하세요."
                      id="vitamin_b1"
                      name="nutrientsNutrient"
                      allowClear
                      onChange={onChange}
                    />
                  </Col>
                ) : (
                  <>
                    {nutrientsNutrient.vitamin_b1 !== 0 ? (
                      <Col
                        span={9}
                        offset={1}
                        style={{
                          border: "groove",
                          height: 30,
                          backgroundColor: "#fff7f7",
                        }}
                      >
                        {nutrientsNutrient.vitamin_b1 + "(mg)"}
                      </Col>
                    ) : (
                      <Col
                        span={9}
                        offset={1}
                        style={{ border: "groove", height: 30 }}
                      >
                        {nutrientsNutrient.vitamin_b1}
                      </Col>
                    )}
                  </>
                )}
              </Row>
              <Row style={{ marginTop: 5 }}>
                <Col
                  span={10}
                  style={{
                    border: "double",
                    backgroundColor: "#eaeaea",
                    paddingLeft: 3,
                    height: 30,
                  }}
                >
                  리보플라빈(비타민 B2)
                </Col>
                {editState ? (
                  <Col
                    span={9}
                    offset={1}
                    style={{ border: "groove", height: 30 }}
                  >
                    <Input
                      style={{ height: 25, border: "none" }}
                      placeholder="수정할 값을 입력하세요."
                      id="vitamin_b2"
                      name="nutrientsNutrient"
                      allowClear
                      onChange={onChange}
                    />
                  </Col>
                ) : (
                  <>
                    {nutrientsNutrient.vitamin_b2 !== 0 ? (
                      <Col
                        span={9}
                        offset={1}
                        style={{
                          border: "groove",
                          height: 30,
                          backgroundColor: "#fff7f7",
                        }}
                      >
                        {nutrientsNutrient.vitamin_b2 + "(mg)"}
                      </Col>
                    ) : (
                      <Col
                        span={9}
                        offset={1}
                        style={{ border: "groove", height: 30 }}
                      >
                        {nutrientsNutrient.vitamin_b2}
                      </Col>
                    )}
                  </>
                )}
              </Row>
              <Row style={{ marginTop: 5 }}>
                <Col
                  span={10}
                  style={{
                    border: "double",
                    backgroundColor: "#eaeaea",
                    paddingLeft: 3,
                    height: 30,
                  }}
                >
                  나이아신(비타민 B3)mg NE
                </Col>
                {editState ? (
                  <Col
                    span={9}
                    offset={1}
                    style={{ border: "groove", height: 30 }}
                  >
                    <Input
                      style={{ height: 25, border: "none" }}
                      placeholder="수정할 값을 입력하세요."
                      id="niacin"
                      name="nutrientsNutrient"
                      allowClear
                      onChange={onChange}
                    />
                  </Col>
                ) : (
                  <>
                    {nutrientsNutrient.niacin !== 0 ? (
                      <Col
                        span={9}
                        offset={1}
                        style={{
                          border: "groove",
                          height: 30,
                          backgroundColor: "#fff7f7",
                        }}
                      >
                        {nutrientsNutrient.niacin + "(mg NE)"}
                      </Col>
                    ) : (
                      <Col
                        span={9}
                        offset={1}
                        style={{ border: "groove", height: 30 }}
                      >
                        {nutrientsNutrient.niacin}
                      </Col>
                    )}
                  </>
                )}
              </Row>
              <Row style={{ marginTop: 5 }}>
                <Col
                  span={10}
                  style={{
                    border: "double",
                    backgroundColor: "#eaeaea",
                    paddingLeft: 3,
                    height: 30,
                  }}
                >
                  판토텐산(비타민 B5)
                </Col>
                {editState ? (
                  <Col
                    span={9}
                    offset={1}
                    style={{ border: "groove", height: 30 }}
                  >
                    <Input
                      style={{ height: 25, border: "none" }}
                      placeholder="수정할 값을 입력하세요."
                      id="pantothenic_acid"
                      name="nutrientsNutrient"
                      allowClear
                      onChange={onChange}
                    />
                  </Col>
                ) : (
                  <>
                    {nutrientsNutrient.pantothenic_acid !== 0 ? (
                      <Col
                        span={9}
                        offset={1}
                        style={{
                          border: "groove",
                          height: 30,
                          backgroundColor: "#fff7f7",
                        }}
                      >
                        {nutrientsNutrient.pantothenic_acid + "(mg)"}
                      </Col>
                    ) : (
                      <Col
                        span={9}
                        offset={1}
                        style={{ border: "groove", height: 30 }}
                      >
                        {nutrientsNutrient.pantothenic_acid}
                      </Col>
                    )}
                  </>
                )}
              </Row>
              <Row style={{ marginTop: 5 }}>
                <Col
                  span={10}
                  style={{
                    border: "double",
                    backgroundColor: "#eaeaea",
                    paddingLeft: 3,
                    height: 30,
                  }}
                >
                  피리독신(비타민 B6)
                </Col>
                {editState ? (
                  <Col
                    span={9}
                    offset={1}
                    style={{ border: "groove", height: 30 }}
                  >
                    <Input
                      style={{ height: 25, border: "none" }}
                      placeholder="수정할 값을 입력하세요."
                      id="pyridoxine"
                      name="nutrientsNutrient"
                      allowClear
                      onChange={onChange}
                    />
                  </Col>
                ) : (
                  <>
                    {nutrientsNutrient.pyridoxine !== 0 ? (
                      <Col
                        span={9}
                        offset={1}
                        style={{
                          border: "groove",
                          height: 30,
                          backgroundColor: "#fff7f7",
                        }}
                      >
                        {nutrientsNutrient.pyridoxine + "(mg)"}
                      </Col>
                    ) : (
                      <Col
                        span={9}
                        offset={1}
                        style={{ border: "groove", height: 30 }}
                      >
                        {nutrientsNutrient.pyridoxine}
                      </Col>
                    )}
                  </>
                )}
              </Row>
              <Row style={{ marginTop: 5 }}>
                <Col
                  span={10}
                  style={{
                    border: "double",
                    backgroundColor: "#eaeaea",
                    paddingLeft: 3,
                    height: 30,
                  }}
                >
                  비오틴(비타민
                </Col>
                {editState ? (
                  <Col
                    span={9}
                    offset={1}
                    style={{ border: "groove", height: 30 }}
                  >
                    <Input
                      style={{ height: 25, border: "none" }}
                      placeholder="수정할 값을 입력하세요."
                      id="biotin"
                      name="nutrientsNutrient"
                      allowClear
                      onChange={onChange}
                    />
                  </Col>
                ) : (
                  <>
                    {nutrientsNutrient.biotin !== 0 ? (
                      <Col
                        span={9}
                        offset={1}
                        style={{
                          border: "groove",
                          height: 30,
                          backgroundColor: "#fff7f7",
                        }}
                      >
                        {nutrientsNutrient.biotin}
                      </Col>
                    ) : (
                      <Col
                        span={9}
                        offset={1}
                        style={{ border: "groove", height: 30 }}
                      >
                        {nutrientsNutrient.biotin}
                      </Col>
                    )}
                  </>
                )}
              </Row>
              <Row style={{ marginTop: 5 }}>
                <Col
                  span={10}
                  style={{
                    border: "double",
                    backgroundColor: "#eaeaea",
                    paddingLeft: 3,
                    height: 30,
                  }}
                >
                  엽산(비타민 B9)
                </Col>
                {editState ? (
                  <Col
                    span={9}
                    offset={1}
                    style={{ border: "groove", height: 30 }}
                  >
                    <Input
                      style={{ height: 25, border: "none" }}
                      placeholder="수정할 값을 입력하세요."
                      id="folic_acid"
                      name="nutrientsNutrient"
                      allowClear
                      onChange={onChange}
                    />
                  </Col>
                ) : (
                  <>
                    {nutrientsNutrient.folic_acid !== 0 ? (
                      <Col
                        span={9}
                        offset={1}
                        style={{
                          border: "groove",
                          height: 30,
                          backgroundColor: "#fff7f7",
                        }}
                      >
                        {nutrientsNutrient.folic_acid + "(㎍)"}
                      </Col>
                    ) : (
                      <Col
                        span={9}
                        offset={1}
                        style={{ border: "groove", height: 30 }}
                      >
                        {nutrientsNutrient.folic_acid}
                      </Col>
                    )}
                  </>
                )}
              </Row>
              <Row style={{ marginTop: 5 }}>
                <Col
                  span={10}
                  style={{
                    border: "double",
                    backgroundColor: "#eaeaea",
                    paddingLeft: 3,
                    height: 30,
                  }}
                >
                  코발라민(비타민 B12)
                </Col>
                {editState ? (
                  <Col
                    span={9}
                    offset={1}
                    style={{ border: "groove", height: 30 }}
                  >
                    <Input
                      style={{ height: 25, border: "none" }}
                      placeholder="수정할 값을 입력하세요."
                      id="vitamin_b12"
                      name="nutrientsNutrient"
                      allowClear
                      onChange={onChange}
                    />
                  </Col>
                ) : (
                  <>
                    {nutrientsNutrient.vitamin_b12 !== 0 ? (
                      <Col
                        span={9}
                        offset={1}
                        style={{
                          border: "groove",
                          height: 30,
                          backgroundColor: "#fff7f7",
                        }}
                      >
                        {nutrientsNutrient.vitamin_b12 + "(㎍)"}
                      </Col>
                    ) : (
                      <Col
                        span={9}
                        offset={1}
                        style={{ border: "groove", height: 30 }}
                      >
                        {nutrientsNutrient.vitamin_b12}
                      </Col>
                    )}
                  </>
                )}
              </Row>
              <Row style={{ marginTop: 5 }}>
                <Col
                  span={10}
                  style={{
                    border: "double",
                    backgroundColor: "#eaeaea",
                    paddingLeft: 3,
                    height: 30,
                    fontSize: "smaller",
                  }}
                >
                  비타민 C
                </Col>
                {editState ? (
                  <Col
                    span={9}
                    offset={1}
                    style={{ border: "groove", height: 30 }}
                  >
                    <Input
                      style={{ height: 25, border: "none" }}
                      placeholder="수정할 값을 입력하세요."
                      id="vitamin_c"
                      name="nutrientsNutrient"
                      allowClear
                      onChange={onChange}
                    />
                  </Col>
                ) : (
                  <>
                    {nutrientsNutrient.vitamin_c !== 0 ? (
                      <Col
                        span={9}
                        offset={1}
                        style={{
                          border: "groove",
                          height: 30,
                          backgroundColor: "#fff7f7",
                        }}
                      >
                        {nutrientsNutrient.vitamin_c + "(mg)"}
                      </Col>
                    ) : (
                      <Col
                        span={9}
                        offset={1}
                        style={{ border: "groove", height: 30 }}
                      >
                        {nutrientsNutrient.vitamin_c}
                      </Col>
                    )}
                  </>
                )}
              </Row>
              <Row style={{ marginTop: 5 }}>
                <Col
                  span={10}
                  style={{
                    border: "double",
                    backgroundColor: "#eaeaea",
                    paddingLeft: 3,
                    height: 30,
                    fontSize: "smaller",
                  }}
                >
                  오메가3
                </Col>
                {editState ? (
                  <Col
                    span={9}
                    offset={1}
                    style={{ border: "groove", height: 30 }}
                  >
                    <Input
                      style={{ height: 25, border: "none" }}
                      placeholder="수정할 값을 입력하세요."
                      id="omega_3_fatty_acids"
                      name="nutrientsNutrient"
                      allowClear
                      onChange={onChange}
                    />
                  </Col>
                ) : (
                  <>
                    {nutrientsNutrient.omega_3_fatty_acids !== 0 ? (
                      <Col
                        span={9}
                        offset={1}
                        style={{
                          border: "groove",
                          height: 30,
                          backgroundColor: "#fff7f7",
                        }}
                      >
                        {nutrientsNutrient.omega_3_fatty_acids + "(mg)"}
                      </Col>
                    ) : (
                      <Col
                        span={9}
                        offset={1}
                        style={{ border: "groove", height: 30 }}
                      >
                        {nutrientsNutrient.omega_3_fatty_acids}
                      </Col>
                    )}
                  </>
                )}
              </Row>
              <Row style={{ marginTop: 5 }}>
                <Col
                  span={10}
                  style={{
                    border: "double",
                    backgroundColor: "#eaeaea",
                    paddingLeft: 3,
                    height: 30,
                  }}
                >
                  베타카로틴
                </Col>
                {editState ? (
                  <Col
                    span={9}
                    offset={1}
                    style={{ border: "groove", height: 30 }}
                  >
                    <Input
                      style={{ height: 25, border: "none" }}
                      placeholder="수정할 값을 입력하세요."
                      id="beta_carotene"
                      name="nutrientsNutrient"
                      allowClear
                      onChange={onChange}
                    />
                  </Col>
                ) : (
                  <>
                    {nutrientsNutrient.beta_carotene !== 0 ? (
                      <Col
                        span={9}
                        offset={1}
                        style={{
                          border: "groove",
                          height: 30,
                          backgroundColor: "#fff7f7",
                        }}
                      >
                        {nutrientsNutrient.beta_carotene}
                      </Col>
                    ) : (
                      <Col
                        span={9}
                        offset={1}
                        style={{ border: "groove", height: 30 }}
                      >
                        {nutrientsNutrient.beta_carotene}
                      </Col>
                    )}
                  </>
                )}
              </Row>
              <Row style={{ marginTop: 5 }}>
                <Col
                  span={10}
                  style={{
                    border: "double",
                    backgroundColor: "#eaeaea",
                    paddingLeft: 3,
                    height: 30,
                  }}
                >
                  크롬
                </Col>
                {editState ? (
                  <Col
                    span={9}
                    offset={1}
                    style={{ border: "groove", height: 30 }}
                  >
                    <Input
                      style={{ height: 25, border: "none" }}
                      placeholder="수정할 값을 입력하세요."
                      id="chrome"
                      name="nutrientsNutrient"
                      allowClear
                      onChange={onChange}
                    />
                  </Col>
                ) : (
                  <>
                    {nutrientsNutrient.chrome !== 0 ? (
                      <Col
                        span={9}
                        offset={1}
                        style={{
                          border: "groove",
                          height: 30,
                          backgroundColor: "#fff7f7",
                        }}
                      >
                        {nutrientsNutrient.chrome + "(㎍)"}
                      </Col>
                    ) : (
                      <Col
                        span={9}
                        offset={1}
                        style={{ border: "groove", height: 30 }}
                      >
                        {nutrientsNutrient.chrome}
                      </Col>
                    )}
                  </>
                )}
              </Row>
              <Row style={{ marginTop: 5 }}>
                <Col
                  span={10}
                  style={{
                    border: "double",
                    backgroundColor: "#eaeaea",
                    paddingLeft: 3,
                    height: 30,
                  }}
                >
                  보장균수(억c
                </Col>
                {editState ? (
                  <Col
                    span={9}
                    offset={1}
                    style={{ border: "groove", height: 30 }}
                  >
                    <Input
                      style={{ height: 25, border: "none" }}
                      placeholder="수정할 값을 입력하세요."
                      id="guaranteed"
                      name="nutrientsNutrient"
                      allowClear
                      onChange={onChange}
                    />
                  </Col>
                ) : (
                  <>
                    {nutrientsNutrient.guaranteed !== 0 ? (
                      <Col
                        span={9}
                        offset={1}
                        style={{
                          border: "groove",
                          height: 30,
                          backgroundColor: "#fff7f7",
                        }}
                      >
                        {nutrientsNutrient.guaranteed + "(억cfu)"}
                      </Col>
                    ) : (
                      <Col
                        span={9}
                        offset={1}
                        style={{ border: "groove", height: 30 }}
                      >
                        {nutrientsNutrient.guaranteed}
                      </Col>
                    )}
                  </>
                )}
              </Row>
              <Row style={{ marginTop: 5 }}>
                <Col
                  span={10}
                  style={{
                    border: "double",
                    backgroundColor: "#eaeaea",
                    paddingLeft: 3,
                    height: 30,
                  }}
                >
                  루테인
                </Col>
                {editState ? (
                  <Col
                    span={9}
                    offset={1}
                    style={{ border: "groove", height: 30 }}
                  >
                    <Input
                      style={{ height: 25, border: "none" }}
                      placeholder="수정할 값을 입력하세요."
                      id="lutein"
                      name="nutrientsNutrient"
                      allowClear
                      onChange={onChange}
                    />
                  </Col>
                ) : (
                  <>
                    {nutrientsNutrient.lutein !== 0 ? (
                      <Col
                        span={9}
                        offset={1}
                        style={{
                          border: "groove",
                          height: 30,
                          backgroundColor: "#fff7f7",
                        }}
                      >
                        {nutrientsNutrient.lutein + "(mg)"}
                      </Col>
                    ) : (
                      <Col
                        span={9}
                        offset={1}
                        style={{ border: "groove", height: 30 }}
                      >
                        {nutrientsNutrient.lutein}
                      </Col>
                    )}
                  </>
                )}
              </Row>
            </Col>
            <Col span={5}>
              <Row>
                <Col
                  span={10}
                  style={{
                    border: "double",
                    backgroundColor: "#eaeaea",
                    paddingLeft: 3,
                    height: 30,
                  }}
                >
                  지아잔틴
                </Col>
                {editState ? (
                  <Col
                    span={9}
                    offset={1}
                    style={{ border: "groove", height: 30 }}
                  >
                    <Input
                      style={{ height: 25, border: "none" }}
                      placeholder="수정할 값을 입력하세요."
                      id="zeaxanthin"
                      name="nutrientsNutrient"
                      allowClear
                      onChange={onChange}
                    />
                  </Col>
                ) : (
                  <>
                    {nutrientsNutrient.zeaxanthin !== 0 ? (
                      <Col
                        span={9}
                        offset={1}
                        style={{
                          border: "groove",
                          height: 30,
                          backgroundColor: "#fff7f7",
                        }}
                      >
                        {nutrientsNutrient.zeaxanthin}
                      </Col>
                    ) : (
                      <Col
                        span={9}
                        offset={1}
                        style={{ border: "groove", height: 30 }}
                      >
                        {nutrientsNutrient.zeaxanthin}
                      </Col>
                    )}
                  </>
                )}
              </Row>
              <Row style={{ marginTop: 5 }}>
                <Col
                  span={10}
                  style={{
                    border: "double",
                    backgroundColor: "#eaeaea",
                    paddingLeft: 3,
                    height: 30,
                  }}
                >
                  아스타잔틴
                </Col>
                {editState ? (
                  <Col
                    span={9}
                    offset={1}
                    style={{ border: "groove", height: 30 }}
                  >
                    <Input
                      style={{ height: 25, border: "none" }}
                      placeholder="수정할 값을 입력하세요."
                      id="astaxanthin"
                      name="nutrientsNutrient"
                      allowClear
                      onChange={onChange}
                    />
                  </Col>
                ) : (
                  <>
                    {nutrientsNutrient.astaxanthin !== 0 ? (
                      <Col
                        span={9}
                        offset={1}
                        style={{
                          border: "groove",
                          height: 30,
                          backgroundColor: "#fff7f7",
                        }}
                      >
                        {nutrientsNutrient.astaxanthin + "(mg)"}
                      </Col>
                    ) : (
                      <Col
                        span={9}
                        offset={1}
                        style={{ border: "groove", height: 30 }}
                      >
                        {nutrientsNutrient.astaxanthin}
                      </Col>
                    )}
                  </>
                )}
              </Row>
              <Row style={{ marginTop: 5 }}>
                <Col
                  span={10}
                  style={{
                    border: "double",
                    backgroundColor: "#eaeaea",
                    paddingLeft: 3,
                    height: 30,
                  }}
                >
                  실리마린
                </Col>
                {editState ? (
                  <Col
                    span={9}
                    offset={1}
                    style={{ border: "groove", height: 30 }}
                  >
                    <Input
                      style={{ height: 25, border: "none" }}
                      placeholder="수정할 값을 입력하세요."
                      id="silymarin"
                      name="nutrientsNutrient"
                      allowClear
                      onChange={onChange}
                    />
                  </Col>
                ) : (
                  <>
                    {nutrientsNutrient.silymarin !== 0 ? (
                      <Col
                        span={9}
                        offset={1}
                        style={{
                          border: "groove",
                          height: 30,
                          backgroundColor: "#fff7f7",
                        }}
                      >
                        {nutrientsNutrient.silymarin + "(mg)"}
                      </Col>
                    ) : (
                      <Col
                        span={9}
                        offset={1}
                        style={{ border: "groove", height: 30 }}
                      >
                        {nutrientsNutrient.silymarin}
                      </Col>
                    )}
                  </>
                )}
              </Row>
              <Row style={{ marginTop: 5 }}>
                <Col
                  span={10}
                  style={{
                    border: "double",
                    backgroundColor: "#eaeaea",
                    paddingLeft: 3,
                    height: 30,
                    fontSize: "smaller",
                  }}
                >
                  CoQ10
                </Col>
                {editState ? (
                  <Col
                    span={9}
                    offset={1}
                    style={{ border: "groove", height: 30 }}
                  >
                    <Input
                      style={{ height: 25, border: "none" }}
                      placeholder="수정할 값을 입력하세요."
                      id="coq10"
                      name="nutrientsNutrient"
                      allowClear
                      onChange={onChange}
                    />
                  </Col>
                ) : (
                  <>
                    {nutrientsNutrient.coq10 !== 0 ? (
                      <Col
                        span={9}
                        offset={1}
                        style={{
                          border: "groove",
                          height: 30,
                          backgroundColor: "#fff7f7",
                        }}
                      >
                        {nutrientsNutrient.coq10 + "(mg)"}
                      </Col>
                    ) : (
                      <Col
                        span={9}
                        offset={1}
                        style={{ border: "groove", height: 30 }}
                      >
                        {nutrientsNutrient.coq10}
                      </Col>
                    )}
                  </>
                )}
              </Row>
              <Row style={{ marginTop: 5 }}>
                <Col
                  span={10}
                  style={{
                    border: "double",
                    backgroundColor: "#eaeaea",
                    paddingLeft: 3,
                    height: 30,
                  }}
                >
                  진세노사이드
                </Col>
                {editState ? (
                  <Col
                    span={9}
                    offset={1}
                    style={{ border: "groove", height: 30 }}
                  >
                    <Input
                      style={{ height: 25, border: "none" }}
                      placeholder="수정할 값을 입력하세요."
                      id="ginsenoside"
                      name="nutrientsNutrient"
                      allowClear
                      onChange={onChange}
                    />
                  </Col>
                ) : (
                  <>
                    {nutrientsNutrient.ginsenoside !== 0 ? (
                      <Col
                        span={9}
                        offset={1}
                        style={{
                          border: "groove",
                          height: 30,
                          backgroundColor: "#fff7f7",
                        }}
                      >
                        {nutrientsNutrient.ginsenoside + "(mg)"}
                      </Col>
                    ) : (
                      <Col
                        span={9}
                        offset={1}
                        style={{ border: "groove", height: 30 }}
                      >
                        {nutrientsNutrient.ginsenoside}
                      </Col>
                    )}
                  </>
                )}
              </Row>
              <Row style={{ marginTop: 5 }}>
                <Col
                  span={10}
                  style={{
                    border: "double",
                    backgroundColor: "#eaeaea",
                    paddingLeft: 3,
                    height: 30,
                  }}
                >
                  플라보노이드
                </Col>
                {editState ? (
                  <Col
                    span={9}
                    offset={1}
                    style={{ border: "groove", height: 30 }}
                  >
                    <Input
                      style={{ height: 25, border: "none" }}
                      placeholder="수정할 값을 입력하세요."
                      id="flavonoids"
                      name="nutrientsNutrient"
                      allowClear
                      onChange={onChange}
                    />
                  </Col>
                ) : (
                  <>
                    {nutrientsNutrient.flavonoids !== 0 ? (
                      <Col
                        span={9}
                        offset={1}
                        style={{
                          border: "groove",
                          height: 30,
                          backgroundColor: "#fff7f7",
                        }}
                      >
                        {nutrientsNutrient.flavonoids + "(mg)"}
                      </Col>
                    ) : (
                      <Col
                        span={9}
                        offset={1}
                        style={{ border: "groove", height: 30 }}
                      >
                        {nutrientsNutrient.flavonoids}
                      </Col>
                    )}
                  </>
                )}
              </Row>
              <Row style={{ marginTop: 5 }}>
                <Col
                  span={10}
                  style={{
                    border: "double",
                    backgroundColor: "#eaeaea",
                    paddingLeft: 3,
                    height: 30,
                  }}
                >
                  테아닌
                </Col>
                {editState ? (
                  <Col
                    span={9}
                    offset={1}
                    style={{ border: "groove", height: 30 }}
                  >
                    <Input
                      style={{ height: 25, border: "none" }}
                      placeholder="수정할 값을 입력하세요."
                      id="theanine"
                      name="nutrientsNutrient"
                      allowClear
                      onChange={onChange}
                    />
                  </Col>
                ) : (
                  <>
                    {nutrientsNutrient.theanine !== 0 ? (
                      <Col
                        span={9}
                        offset={1}
                        style={{
                          border: "groove",
                          height: 30,
                          backgroundColor: "#fff7f7",
                        }}
                      >
                        {nutrientsNutrient.theanine + "(mg)"}
                      </Col>
                    ) : (
                      <Col
                        span={9}
                        offset={1}
                        style={{ border: "groove", height: 30 }}
                      >
                        {nutrientsNutrient.theanine}
                      </Col>
                    )}
                  </>
                )}
              </Row>
              <Row style={{ marginTop: 5 }}>
                <Col
                  span={10}
                  style={{
                    border: "double",
                    backgroundColor: "#eaeaea",
                    paddingLeft: 3,
                    height: 30,
                  }}
                >
                  콜라겐
                </Col>
                {editState ? (
                  <Col
                    span={9}
                    offset={1}
                    style={{ border: "groove", height: 30 }}
                  >
                    <Input
                      style={{ height: 25, border: "none" }}
                      placeholder="수정할 값을 입력하세요."
                      id="collagen"
                      name="nutrientsNutrient"
                      allowClear
                      onChange={onChange}
                    />
                  </Col>
                ) : (
                  <>
                    {nutrientsNutrient.collagen !== 0 ? (
                      <Col
                        span={9}
                        offset={1}
                        style={{
                          border: "groove",
                          height: 30,
                          backgroundColor: "#fff7f7",
                        }}
                      >
                        {nutrientsNutrient.collagen}
                      </Col>
                    ) : (
                      <Col
                        span={9}
                        offset={1}
                        style={{ border: "groove", height: 30 }}
                      >
                        {nutrientsNutrient.collagen}
                      </Col>
                    )}
                  </>
                )}
              </Row>
              <Row style={{ marginTop: 5 }}>
                <Col
                  span={10}
                  style={{
                    border: "double",
                    backgroundColor: "#eaeaea",
                    paddingLeft: 3,
                    height: 30,
                  }}
                >
                  L-라이신
                </Col>
                {editState ? (
                  <Col
                    span={9}
                    offset={1}
                    style={{ border: "groove", height: 30 }}
                  >
                    <Input
                      style={{ height: 25, border: "none" }}
                      placeholder="수정할 값을 입력하세요."
                      id="l_lysine"
                      name="nutrientsNutrient"
                      allowClear
                      onChange={onChange}
                    />
                  </Col>
                ) : (
                  <>
                    {nutrientsNutrient.l_lysine !== 0 ? (
                      <Col
                        span={9}
                        offset={1}
                        style={{
                          border: "groove",
                          height: 30,
                          backgroundColor: "#fff7f7",
                        }}
                      >
                        {nutrientsNutrient.l_lysine}
                      </Col>
                    ) : (
                      <Col
                        span={9}
                        offset={1}
                        style={{ border: "groove", height: 30 }}
                      >
                        {nutrientsNutrient.l_lysine}
                      </Col>
                    )}
                  </>
                )}
              </Row>
              <Row style={{ marginTop: 5 }}>
                <Col
                  span={10}
                  style={{
                    border: "double",
                    backgroundColor: "#eaeaea",
                    paddingLeft: 3,
                    height: 30,
                  }}
                >
                  L-아르기닌
                </Col>
                {editState ? (
                  <Col
                    span={9}
                    offset={1}
                    style={{ border: "groove", height: 30 }}
                  >
                    <Input
                      style={{ height: 25, border: "none" }}
                      placeholder="수정할 값을 입력하세요."
                      id="l_arginine"
                      name="nutrientsNutrient"
                      allowClear
                      onChange={onChange}
                    />
                  </Col>
                ) : (
                  <>
                    {nutrientsNutrient.l_arginine !== 0 ? (
                      <Col
                        span={9}
                        offset={1}
                        style={{
                          border: "groove",
                          height: 30,
                          backgroundColor: "#fff7f7",
                        }}
                      >
                        {nutrientsNutrient.l_arginine}
                      </Col>
                    ) : (
                      <Col
                        span={9}
                        offset={1}
                        style={{ border: "groove", height: 30 }}
                      >
                        {nutrientsNutrient.l_arginine}
                      </Col>
                    )}
                  </>
                )}
              </Row>
              <Row style={{ marginTop: 5 }}>
                <Col
                  span={10}
                  style={{
                    border: "double",
                    backgroundColor: "#eaeaea",
                    paddingLeft: 3,
                    height: 30,
                  }}
                >
                  이노시톨
                </Col>
                {editState ? (
                  <Col
                    span={9}
                    offset={1}
                    style={{ border: "groove", height: 30 }}
                  >
                    <Input
                      style={{ height: 25, border: "none" }}
                      placeholder="수정할 값을 입력하세요."
                      id="inositol"
                      name="nutrientsNutrient"
                      allowClear
                      onChange={onChange}
                    />
                  </Col>
                ) : (
                  <>
                    {nutrientsNutrient.inositol !== 0 ? (
                      <Col
                        span={9}
                        offset={1}
                        style={{
                          border: "groove",
                          height: 30,
                          backgroundColor: "#fff7f7",
                        }}
                      >
                        {nutrientsNutrient.inositol}
                      </Col>
                    ) : (
                      <Col
                        span={9}
                        offset={1}
                        style={{ border: "groove", height: 30 }}
                      >
                        {nutrientsNutrient.inositol}
                      </Col>
                    )}
                  </>
                )}
              </Row>
              <Row style={{ marginTop: 5 }}>
                <Col
                  span={10}
                  style={{
                    border: "double",
                    backgroundColor: "#eaeaea",
                    paddingLeft: 3,
                    height: 30,
                  }}
                >
                  옥타코사놀
                </Col>
                {editState ? (
                  <Col
                    span={9}
                    offset={1}
                    style={{ border: "groove", height: 30 }}
                  >
                    <Input
                      style={{ height: 25, border: "none" }}
                      placeholder="수정할 값을 입력하세요."
                      id="octacosanol"
                      name="nutrientsNutrient"
                      allowClear
                      onChange={onChange}
                    />
                  </Col>
                ) : (
                  <>
                    {nutrientsNutrient.octacosanol !== 0 ? (
                      <Col
                        span={9}
                        offset={1}
                        style={{
                          border: "groove",
                          height: 30,
                          backgroundColor: "#fff7f7",
                        }}
                      >
                        {nutrientsNutrient.octacosanol}
                      </Col>
                    ) : (
                      <Col
                        span={9}
                        offset={1}
                        style={{ border: "groove", height: 30 }}
                      >
                        {nutrientsNutrient.octacosanol}
                      </Col>
                    )}
                  </>
                )}
              </Row>
              <Row style={{ marginTop: 5 }}>
                <Col
                  span={10}
                  style={{
                    border: "double",
                    backgroundColor: "#eaeaea",
                    paddingLeft: 3,
                    height: 30,
                  }}
                >
                  HCA
                </Col>
                {editState ? (
                  <Col
                    span={9}
                    offset={1}
                    style={{ border: "groove", height: 30 }}
                  >
                    <Input
                      style={{ height: 25, border: "none" }}
                      placeholder="수정할 값을 입력하세요."
                      id="hca"
                      name="nutrientsNutrient"
                      allowClear
                      onChange={onChange}
                    />
                  </Col>
                ) : (
                  <>
                    {nutrientsNutrient.hca !== 0 ? (
                      <Col
                        span={9}
                        offset={1}
                        style={{
                          border: "groove",
                          height: 30,
                          backgroundColor: "#fff7f7",
                        }}
                      >
                        {nutrientsNutrient.hca}
                      </Col>
                    ) : (
                      <Col
                        span={9}
                        offset={1}
                        style={{ border: "groove", height: 30 }}
                      >
                        {nutrientsNutrient.hca}
                      </Col>
                    )}
                  </>
                )}
              </Row>
              <Row style={{ marginTop: 5 }}>
                <Col
                  span={10}
                  style={{
                    border: "double",
                    backgroundColor: "#eaeaea",
                    paddingLeft: 3,
                    height: 30,
                  }}
                >
                  UDCA
                </Col>
                {editState ? (
                  <Col
                    span={9}
                    offset={1}
                    style={{ border: "groove", height: 30 }}
                  >
                    <Input
                      style={{ height: 25, border: "none" }}
                      placeholder="수정할 값을 입력하세요."
                      id="udca"
                      name="nutrientsNutrient"
                      allowClear
                      onChange={onChange}
                    />
                  </Col>
                ) : (
                  <>
                    {nutrientsNutrient.udca !== 0 ? (
                      <Col
                        span={9}
                        offset={1}
                        style={{
                          border: "groove",
                          height: 30,
                          backgroundColor: "#fff7f7",
                        }}
                      >
                        {nutrientsNutrient.udca}
                      </Col>
                    ) : (
                      <Col
                        span={9}
                        offset={1}
                        style={{ border: "groove", height: 30 }}
                      >
                        {nutrientsNutrient.udca}
                      </Col>
                    )}
                  </>
                )}
              </Row>
            </Col>
            <Col span={5}>
              <Row>
                <Col
                  span={10}
                  style={{
                    border: "double",
                    backgroundColor: "#eaeaea",
                    paddingLeft: 3,
                    height: 30,
                  }}
                >
                  γ-오리자놀
                </Col>
                {editState ? (
                  <Col
                    span={9}
                    offset={1}
                    style={{ border: "groove", height: 30 }}
                  >
                    <Input
                      style={{ height: 25, border: "none" }}
                      placeholder="수정할 값을 입력하세요."
                      id="γ_oryzanol"
                      name="nutrientsNutrient"
                      allowClear
                      onChange={onChange}
                    />
                  </Col>
                ) : (
                  <>
                    {nutrientsNutrient.γ_oryzanol !== 0 ? (
                      <Col
                        span={9}
                        offset={1}
                        style={{
                          border: "groove",
                          height: 30,
                          backgroundColor: "#fff7f7",
                        }}
                      >
                        {nutrientsNutrient.γ_oryzanol}
                      </Col>
                    ) : (
                      <Col
                        span={9}
                        offset={1}
                        style={{ border: "groove", height: 30 }}
                      >
                        {nutrientsNutrient.γ_oryzanol}
                      </Col>
                    )}
                  </>
                )}
              </Row>
              <Row style={{ marginTop: 5 }}>
                <Col
                  span={10}
                  style={{
                    border: "double",
                    backgroundColor: "#eaeaea",
                    paddingLeft: 3,
                    height: 30,
                  }}
                >
                  글루코사민
                </Col>
                {editState ? (
                  <Col
                    span={9}
                    offset={1}
                    style={{ border: "groove", height: 30 }}
                  >
                    <Input
                      style={{ height: 25, border: "none" }}
                      placeholder="수정할 값을 입력하세요."
                      id="glucosamine"
                      name="nutrientsNutrient"
                      allowClear
                      onChange={onChange}
                    />
                  </Col>
                ) : (
                  <>
                    {nutrientsNutrient.glucosamine !== 0 ? (
                      <Col
                        span={9}
                        offset={1}
                        style={{
                          border: "groove",
                          height: 30,
                          backgroundColor: "#fff7f7",
                        }}
                      >
                        {nutrientsNutrient.glucosamine}
                      </Col>
                    ) : (
                      <Col
                        span={9}
                        offset={1}
                        style={{ border: "groove", height: 30 }}
                      >
                        {nutrientsNutrient.glucosamine}
                      </Col>
                    )}
                  </>
                )}
              </Row>
              <Row style={{ marginTop: 5 }}>
                <Col
                  span={10}
                  style={{
                    border: "double",
                    backgroundColor: "#eaeaea",
                    paddingLeft: 3,
                    height: 30,
                  }}
                >
                  베타글루칸
                </Col>
                {editState ? (
                  <Col
                    span={9}
                    offset={1}
                    style={{ border: "groove", height: 30 }}
                  >
                    <Input
                      style={{ height: 25, border: "none" }}
                      placeholder="수정할 값을 입력하세요."
                      id="betaglucan"
                      name="nutrientsNutrient"
                      allowClear
                      onChange={onChange}
                    />
                  </Col>
                ) : (
                  <>
                    {nutrientsNutrient.betaglucan !== 0 ? (
                      <Col
                        span={9}
                        offset={1}
                        style={{
                          border: "groove",
                          height: 30,
                          backgroundColor: "#fff7f7",
                        }}
                      >
                        {nutrientsNutrient.betaglucan}
                      </Col>
                    ) : (
                      <Col
                        span={9}
                        offset={1}
                        style={{ border: "groove", height: 30 }}
                      >
                        {nutrientsNutrient.betaglucan}
                      </Col>
                    )}
                  </>
                )}
              </Row>
              <Row style={{ marginTop: 5 }}>
                <Col
                  span={10}
                  style={{
                    border: "double",
                    backgroundColor: "#eaeaea",
                    paddingLeft: 3,
                    height: 30,
                    fontSize: "smaller",
                  }}
                >
                  맥주효모
                </Col>
                {editState ? (
                  <Col
                    span={9}
                    offset={1}
                    style={{ border: "groove", height: 30 }}
                  >
                    <Input
                      style={{ height: 25, border: "none" }}
                      placeholder="수정할 값을 입력하세요."
                      id="brewersyeast"
                      name="nutrientsNutrient"
                      allowClear
                      onChange={onChange}
                    />
                  </Col>
                ) : (
                  <>
                    {nutrientsNutrient.brewersyeast !== 0 ? (
                      <Col
                        span={9}
                        offset={1}
                        style={{
                          border: "groove",
                          height: 30,
                          backgroundColor: "#fff7f7",
                        }}
                      >
                        {nutrientsNutrient.brewersyeast}
                      </Col>
                    ) : (
                      <Col
                        span={9}
                        offset={1}
                        style={{ border: "groove", height: 30 }}
                      >
                        {nutrientsNutrient.brewersyeast}
                      </Col>
                    )}
                  </>
                )}
              </Row>
              <Row style={{ marginTop: 5 }}>
                <Col
                  span={10}
                  style={{
                    border: "double",
                    backgroundColor: "#eaeaea",
                    paddingLeft: 3,
                    height: 30,
                  }}
                >
                  오로트산수화물
                </Col>
                {editState ? (
                  <Col
                    span={9}
                    offset={1}
                    style={{ border: "groove", height: 30 }}
                  >
                    <Input
                      style={{ height: 25, border: "none" }}
                      placeholder="수정할 값을 입력하세요."
                      id="oroticacidhydrate"
                      name="nutrientsNutrient"
                      allowClear
                      onChange={onChange}
                    />
                  </Col>
                ) : (
                  <>
                    {nutrientsNutrient.oroticacidhydrate !== 0 ? (
                      <Col
                        span={9}
                        offset={1}
                        style={{
                          border: "groove",
                          height: 30,
                          backgroundColor: "#fff7f7",
                        }}
                      >
                        {nutrientsNutrient.oroticacidhydrate}
                      </Col>
                    ) : (
                      <Col
                        span={9}
                        offset={1}
                        style={{ border: "groove", height: 30 }}
                      >
                        {nutrientsNutrient.oroticacidhydrate}
                      </Col>
                    )}
                  </>
                )}
              </Row>
              <Row style={{ marginTop: 5 }}>
                <Col
                  span={10}
                  style={{
                    border: "double",
                    backgroundColor: "#eaeaea",
                    paddingLeft: 3,
                    height: 30,
                  }}
                >
                  히알루론산
                </Col>
                {editState ? (
                  <Col
                    span={9}
                    offset={1}
                    style={{ border: "groove", height: 30 }}
                  >
                    <Input
                      style={{ height: 25, border: "none" }}
                      placeholder="수정할 값을 입력하세요."
                      id="hyaluronic_acid"
                      name="nutrientsNutrient"
                      allowClear
                      onChange={onChange}
                    />
                  </Col>
                ) : (
                  <>
                    {nutrientsNutrient.hyaluronic_acid !== 0 ? (
                      <Col
                        span={9}
                        offset={1}
                        style={{
                          border: "groove",
                          height: 30,
                          backgroundColor: "#fff7f7",
                        }}
                      >
                        {nutrientsNutrient.hyaluronic_acid + "(mg)"}
                      </Col>
                    ) : (
                      <Col
                        span={9}
                        offset={1}
                        style={{ border: "groove", height: 30 }}
                      >
                        {nutrientsNutrient.hyaluronic_acid}
                      </Col>
                    )}
                  </>
                )}
              </Row>
              <Row style={{ marginTop: 5 }}>
                <Col
                  span={10}
                  style={{
                    border: "double",
                    backgroundColor: "#eaeaea",
                    paddingLeft: 3,
                    height: 30,
                  }}
                >
                  폴리감마글루탐산
                </Col>
                {editState ? (
                  <Col
                    span={9}
                    offset={1}
                    style={{ border: "groove", height: 30 }}
                  >
                    <Input
                      style={{ height: 25, border: "none" }}
                      placeholder="수정할 값을 입력하세요."
                      id="glutamic_acid"
                      name="nutrientsNutrient"
                      allowClear
                      onChange={onChange}
                    />
                  </Col>
                ) : (
                  <>
                    {nutrientsNutrient.glutamic_acid !== 0 ? (
                      <Col
                        span={9}
                        offset={1}
                        style={{
                          border: "groove",
                          height: 30,
                          backgroundColor: "#fff7f7",
                        }}
                      >
                        {nutrientsNutrient.glutamic_acid + "(mg)"}
                      </Col>
                    ) : (
                      <Col
                        span={9}
                        offset={1}
                        style={{ border: "groove", height: 30 }}
                      >
                        {nutrientsNutrient.glutamic_acid}
                      </Col>
                    )}
                  </>
                )}
              </Row>
              <Row style={{ marginTop: 5 }}>
                <Col
                  span={10}
                  style={{
                    border: "double",
                    backgroundColor: "#eaeaea",
                    paddingLeft: 3,
                    height: 30,
                  }}
                >
                  MSM
                </Col>
                {editState ? (
                  <Col
                    span={9}
                    offset={1}
                    style={{ border: "groove", height: 30 }}
                  >
                    <Input
                      style={{ height: 25, border: "none" }}
                      placeholder="수정할 값을 입력하세요."
                      id="msm"
                      name="nutrientsNutrient"
                      allowClear
                      onChange={onChange}
                    />
                  </Col>
                ) : (
                  <>
                    {nutrientsNutrient.msm !== 0 ? (
                      <Col
                        span={9}
                        offset={1}
                        style={{
                          border: "groove",
                          height: 30,
                          backgroundColor: "#fff7f7",
                        }}
                      >
                        {nutrientsNutrient.msm}
                      </Col>
                    ) : (
                      <Col
                        span={9}
                        offset={1}
                        style={{ border: "groove", height: 30 }}
                      >
                        {nutrientsNutrient.msm}
                      </Col>
                    )}
                  </>
                )}
              </Row>
              <Row style={{ marginTop: 5 }}>
                <Col
                  span={10}
                  style={{
                    border: "double",
                    backgroundColor: "#eaeaea",
                    paddingLeft: 3,
                    height: 30,
                  }}
                >
                  총안토시아노사이드
                </Col>
                {editState ? (
                  <Col
                    span={9}
                    offset={1}
                    style={{ border: "groove", height: 30 }}
                  >
                    <Input
                      style={{ height: 25, border: "none" }}
                      placeholder="수정할 값을 입력하세요."
                      id="total_anthocyanosides"
                      name="nutrientsNutrient"
                      allowClear
                      onChange={onChange}
                    />
                  </Col>
                ) : (
                  <>
                    {nutrientsNutrient.total_anthocyanosides !== 0 ? (
                      <Col
                        span={9}
                        offset={1}
                        style={{
                          border: "groove",
                          height: 30,
                          backgroundColor: "#fff7f7",
                        }}
                      >
                        {nutrientsNutrient.total_anthocyanosides}
                      </Col>
                    ) : (
                      <Col
                        span={9}
                        offset={1}
                        style={{ border: "groove", height: 30 }}
                      >
                        {nutrientsNutrient.total_anthocyanosides}
                      </Col>
                    )}
                  </>
                )}
              </Row>
              <Row style={{ marginTop: 5 }}>
                <Col
                  span={10}
                  style={{
                    border: "double",
                    backgroundColor: "#eaeaea",
                    paddingLeft: 3,
                    height: 30,
                  }}
                >
                  알파에스1카제인
                </Col>
                {editState ? (
                  <Col
                    span={9}
                    offset={1}
                    style={{ border: "groove", height: 30 }}
                  >
                    <Input
                      style={{ height: 25, border: "none" }}
                      placeholder="수정할 값을 입력하세요."
                      id="alpha_s_1_casein"
                      name="nutrientsNutrient"
                      allowClear
                      onChange={onChange}
                    />
                  </Col>
                ) : (
                  <>
                    {nutrientsNutrient.alpha_s_1_casein !== 0 ? (
                      <Col
                        span={9}
                        offset={1}
                        style={{
                          border: "groove",
                          height: 30,
                          backgroundColor: "#fff7f7",
                        }}
                      >
                        {nutrientsNutrient.alpha_s_1_casein}
                      </Col>
                    ) : (
                      <Col
                        span={9}
                        offset={1}
                        style={{ border: "groove", height: 30 }}
                      >
                        {nutrientsNutrient.alpha_s_1_casein}
                      </Col>
                    )}
                  </>
                )}
              </Row>
              <Row style={{ marginTop: 5 }}>
                <Col
                  span={10}
                  style={{
                    border: "double",
                    backgroundColor: "#eaeaea",
                    paddingLeft: 3,
                    height: 30,
                  }}
                >
                  열처리배양균체 수
                </Col>
                {editState ? (
                  <Col
                    span={9}
                    offset={1}
                    style={{ border: "groove", height: 30 }}
                  >
                    <Input
                      style={{ height: 25, border: "none" }}
                      placeholder="수정할 값을 입력하세요."
                      id="cultured_cells"
                      name="nutrientsNutrient"
                      allowClear
                      onChange={onChange}
                    />
                  </Col>
                ) : (
                  <>
                    {nutrientsNutrient.cultured_cells !== 0 ? (
                      <Col
                        span={9}
                        offset={1}
                        style={{
                          border: "groove",
                          height: 30,
                          backgroundColor: "#fff7f7",
                        }}
                      >
                        {nutrientsNutrient.cultured_cells}
                      </Col>
                    ) : (
                      <Col
                        span={9}
                        offset={1}
                        style={{ border: "groove", height: 30 }}
                      >
                        {nutrientsNutrient.cultured_cells}
                      </Col>
                    )}
                  </>
                )}
              </Row>
              <Row style={{ marginTop: 5 }}>
                <Col
                  span={10}
                  style={{
                    border: "double",
                    backgroundColor: "#eaeaea",
                    paddingLeft: 3,
                    height: 30,
                  }}
                >
                  로사빈
                </Col>
                {editState ? (
                  <Col
                    span={9}
                    offset={1}
                    style={{ border: "groove", height: 30 }}
                  >
                    <Input
                      style={{ height: 25, border: "none" }}
                      placeholder="수정할 값을 입력하세요."
                      id="rosabine"
                      name="nutrientsNutrient"
                      allowClear
                      onChange={onChange}
                    />
                  </Col>
                ) : (
                  <>
                    {nutrientsNutrient.rosabine !== 0 ? (
                      <Col
                        span={9}
                        offset={1}
                        style={{
                          border: "groove",
                          height: 30,
                          backgroundColor: "#fff7f7",
                        }}
                      >
                        {nutrientsNutrient.rosabine}
                      </Col>
                    ) : (
                      <Col
                        span={9}
                        offset={1}
                        style={{ border: "groove", height: 30 }}
                      >
                        {nutrientsNutrient.rosabine}
                      </Col>
                    )}
                  </>
                )}
              </Row>
              <Row style={{ marginTop: 5 }}>
                <Col
                  span={10}
                  style={{
                    border: "double",
                    backgroundColor: "#eaeaea",
                    paddingLeft: 3,
                    height: 30,
                  }}
                >
                  로르산
                </Col>
                {editState ? (
                  <Col
                    span={9}
                    offset={1}
                    style={{ border: "groove", height: 30 }}
                  >
                    <Input
                      style={{ height: 25, border: "none" }}
                      placeholder="수정할 값을 입력하세요."
                      id="lauric_acid"
                      name="nutrientsNutrient"
                      allowClear
                      onChange={onChange}
                    />
                  </Col>
                ) : (
                  <>
                    {nutrientsNutrient.lauric_acid !== 0 ? (
                      <Col
                        span={9}
                        offset={1}
                        style={{
                          border: "groove",
                          height: 30,
                          backgroundColor: "#fff7f7",
                        }}
                      >
                        {nutrientsNutrient.lauric_acid}
                      </Col>
                    ) : (
                      <Col
                        span={9}
                        offset={1}
                        style={{ border: "groove", height: 30 }}
                      >
                        {nutrientsNutrient.lauric_acid}
                      </Col>
                    )}
                  </>
                )}
              </Row>
              <Row style={{ marginTop: 5 }}>
                <Col
                  span={10}
                  style={{
                    border: "double",
                    backgroundColor: "#eaeaea",
                    paddingLeft: 3,
                    height: 30,
                    fontSize: "smaller",
                  }}
                >
                  감마리놀렌산
                </Col>
                {editState ? (
                  <Col
                    span={9}
                    offset={1}
                    style={{ border: "groove", height: 30 }}
                  >
                    <Input
                      style={{ height: 25, border: "none" }}
                      placeholder="수정할 값을 입력하세요."
                      id="linolenic_acid"
                      name="nutrientsNutrient"
                      allowClear
                      onChange={onChange}
                    />
                  </Col>
                ) : (
                  <>
                    {nutrientsNutrient.linolenic_acid !== 0 ? (
                      <Col
                        span={9}
                        offset={1}
                        style={{
                          border: "groove",
                          height: 30,
                          backgroundColor: "#fff7f7",
                        }}
                      >
                        {nutrientsNutrient.linolenic_acid + "(mg)"}
                      </Col>
                    ) : (
                      <Col
                        span={9}
                        offset={1}
                        style={{ border: "groove", height: 30 }}
                      >
                        {nutrientsNutrient.linolenic_acid}
                      </Col>
                    )}
                  </>
                )}
              </Row>
            </Col>
            <Col span={5}>
              <Row>
                <Col
                  span={10}
                  style={{
                    border: "double",
                    backgroundColor: "#eaeaea",
                    paddingLeft: 3,
                    height: 30,
                    fontSize: "smaller",
                  }}
                >
                  녹차추출물(카테킨)
                </Col>
                {editState ? (
                  <Col
                    span={9}
                    offset={1}
                    style={{ border: "groove", height: 30 }}
                  >
                    <Input
                      style={{ height: 25, border: "none" }}
                      placeholder="수정할 값을 입력하세요."
                      id="catechins"
                      name="nutrientsNutrient"
                      allowClear
                      onChange={onChange}
                    />
                  </Col>
                ) : (
                  <>
                    {nutrientsNutrient.catechins !== 0 ? (
                      <Col
                        span={9}
                        offset={1}
                        style={{
                          border: "groove",
                          height: 30,
                          backgroundColor: "#fff7f7",
                        }}
                      >
                        {nutrientsNutrient.catechins + "(mg)"}
                      </Col>
                    ) : (
                      <Col
                        span={9}
                        offset={1}
                        style={{ border: "groove", height: 30 }}
                      >
                        {nutrientsNutrient.catechins}
                      </Col>
                    )}
                  </>
                )}
              </Row>
              <Row style={{ marginTop: 5 }}>
                <Col
                  span={10}
                  style={{
                    border: "double",
                    backgroundColor: "#eaeaea",
                    paddingLeft: 3,
                    height: 30,
                  }}
                >
                  락추로스
                </Col>
                {editState ? (
                  <Col
                    span={9}
                    offset={1}
                    style={{ border: "groove", height: 30 }}
                  >
                    <Input
                      style={{ height: 25, border: "none" }}
                      placeholder="수정할 값을 입력하세요."
                      id="lactulose"
                      name="nutrientsNutrient"
                      allowClear
                      onChange={onChange}
                    />
                  </Col>
                ) : (
                  <>
                    {nutrientsNutrient.lactulose !== 0 ? (
                      <Col
                        span={9}
                        offset={1}
                        style={{
                          border: "groove",
                          height: 30,
                          backgroundColor: "#fff7f7",
                        }}
                      >
                        {nutrientsNutrient.lactulose + "(mg)"}
                      </Col>
                    ) : (
                      <Col
                        span={9}
                        offset={1}
                        style={{ border: "groove", height: 30 }}
                      >
                        {nutrientsNutrient.lactulose}
                      </Col>
                    )}
                  </>
                )}
              </Row>

              <Row style={{ marginTop: 245 }}>
                <Col
                  span={21}
                  style={{
                    textAlign: "center",
                    border: "groove",
                    height: 30,
                    marginBottom: 5,
                  }}
                >
                  생성 및 수정 정보
                </Col>
              </Row>
              <Row style={{ marginTop: 5 }}>
                <Col
                  span={10}
                  style={{
                    border: "double",
                    backgroundColor: "#eaeaea",
                    paddingLeft: 3,
                    height: 30,
                  }}
                >
                  생성일
                </Col>
                {editState ? (
                  <Col
                    span={10}
                    offset={1}
                    style={{ border: "groove", height: 30 }}
                  >
                    <Input
                      style={{
                        height: 25,
                        border: "none",
                        fontSize: "smaller",
                        width: 110,
                      }}
                      placeholder="입력대기중..."
                      id="created_at"
                      name="nutrients"
                      bordered={false}
                      disabled
                      onChange={onChange}
                    />
                  </Col>
                ) : (
                  <Col
                    span={10}
                    offset={1}
                    style={{
                      border: "groove",
                      height: 30,
                      fontSize: "smaller",
                    }}
                  >
                    {nutrientsData.created_at === null ||
                    nutrientsData.created_at === ""
                      ? ""
                      : moment(nutrientsData.created_at).format("YYYY-MM-DD")}
                  </Col>
                )}
              </Row>
              <Row style={{ marginTop: 5 }}>
                <Col
                  span={10}
                  style={{
                    border: "double",
                    backgroundColor: "#eaeaea",
                    paddingLeft: 3,
                    height: 30,
                  }}
                >
                  생성자
                </Col>
                {editState ? (
                  <Col
                    span={10}
                    offset={1}
                    style={{ border: "groove", height: 30 }}
                  >
                    <Input
                      style={{ height: 25, border: "none" }}
                      placeholder="입력대기중..."
                      id="created_by_name"
                      name="nutrients"
                      allowClear
                      onChange={onChange}
                    />
                  </Col>
                ) : (
                  <Col
                    span={10}
                    offset={1}
                    style={{ border: "groove", height: 30 }}
                  >
                    {nutrientsData.created_by_name}
                  </Col>
                )}
              </Row>
              <Row style={{ marginTop: 5 }}>
                <Col
                  span={10}
                  style={{
                    border: "double",
                    backgroundColor: "#eaeaea",
                    paddingLeft: 3,
                    height: 30,
                  }}
                >
                  수정일
                </Col>
                {editState ? (
                  <Col
                    span={10}
                    offset={1}
                    style={{ border: "groove", height: 30 }}
                  >
                    <Input
                      style={{
                        height: 25,
                        border: "none",
                        fontSize: "smaller",
                        width: 110,
                      }}
                      placeholder="입력대기중..."
                      id="updated_at"
                      name="nutrients"
                      bordered={false}
                      disabled
                      onChange={onChange}
                    />
                  </Col>
                ) : (
                  <Col
                    span={10}
                    offset={1}
                    style={{
                      border: "groove",
                      height: 30,
                      fontSize: "smaller",
                    }}
                  >
                    {nutrientsData.updated_at === null ||
                    nutrientsData.updated_at === ""
                      ? "-"
                      : moment(nutrientsData.updated_at).format("YYYY-MM-DD")}
                  </Col>
                )}
              </Row>
              <Row style={{ marginTop: 5 }}>
                <Col
                  span={10}
                  style={{
                    border: "double",
                    backgroundColor: "#eaeaea",
                    paddingLeft: 3,
                    height: 30,
                  }}
                >
                  수정자
                </Col>
                {editState ? (
                  <Col
                    span={10}
                    offset={1}
                    style={{ border: "groove", height: 30 }}
                  >
                    <Input
                      style={{ height: 25, border: "none" }}
                      placeholder="입력대기중..."
                      id="updated_by_name"
                      name="nutrients"
                      allowClear
                      onChange={onChange}
                    />
                  </Col>
                ) : (
                  <Col
                    span={10}
                    offset={1}
                    style={{ border: "groove", height: 30 }}
                  >
                    {nutrientsData.updated_by_name}
                  </Col>
                )}
              </Row>
              <ButtonGroup
                style={{
                  marginTop: 10,
                  marginRight: 25,
                  display: "flex",
                  justifyContent: "flex-end",
                }}
              >
                {editState ? (
                  <>
                    <Button
                      style={{
                        width: 90,
                        height: 30,
                        backgroundColor: "red",
                        color: "white",
                      }}
                      onClick={(e) => handleClickCancel(e)}
                    >
                      취소하기
                    </Button>
                    <Button
                      style={{ width: 90, height: 30, marginLeft: 10 }}
                      type={"primary"}
                      onClick={(e) => handleClickComplete(e)}
                    >
                      저장하기
                    </Button>
                  </>
                ) : (
                  <></>
                )}
              </ButtonGroup>
            </Col>
          </Row>
        </Col>
      </Row>
    </div>
  );
};

export default NutrientsRequestCreateComponent;
